// extracted by mini-css-extract-plugin
module.exports = {"primarycontainer_Promo":"Promo_primarycontainer_Promo__1LEIW","secondaryContainer":"Promo_secondaryContainer__3heEx","container_multipleItem":"Promo_container_multipleItem__3vzPT"};